const enabledStripeBilling = process.env.REACT_APP_ENABLED_STRIPE_BILLING
  ? Boolean(process.env.REACT_APP_ENABLED_STRIPE_BILLING)
  : false;

export default enabledStripeBilling;
